// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*DBC Override*/
::ng-deep mat-label {
  font-size: 16px !important;
}

::ng-deep .mat-input-element {
  font-size: 16px !important;
}

::ng-deep .mat-select {
  font-size: 16px !important;
}

.dbc-material-form {
  min-width: 150px;
  max-width: 500px;
  width: 100%;
}

.dbc-material-full-width {
  width: 100%;
}

.gallery-Prod-Version {
  position: relative;
  transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1);
  opacity: 1;
  display: inline-block;
  max-height: 250px;
  max-width: 250px;
  zoom: 1;
  vertical-align: bottom;
  margin: 3px;
}

.gallery-Prod-Version-Item {
  max-height: 250px;
  max-width: 250px;
}

.selectedImage {
  width: 20px;
  height: 20px;
  position: absolute;
  left: 120px;
  margin-top: -118px;
}

div.scroll-list {
  overflow: auto;
  max-height: 70vh;
}

.drag-over {
  border: #ff525b dashed 2px;
}

.drag-hint {
  border: #ffc100 dashed 2px;
}

.drag-target-border {
  border: #00bfff dashed 2px;
}

.nav-link.active {
  background-color: #eaeaea !important;
}

.defaultImage {
  border-left: 10px solid #28a745;
}

.my-code-editor .editorContainer {
  height: calc(100vh - 100px);
}

.green-tick {
  color: green;
}

.yellow-tick {
  color: yellow;
}

.red-tick {
  color: red;
}

.selected-image {
  border: 2px solid #28a745 !important;
}

select.mySelectArrow {
  appearance: none;
  outline: 1px solid;
  border-radius: 5px;
  border: none;
  color: #1e82ae;
  width: 100%;
  padding: 5px 5px;
  font-size: 15px;
}

select.mySelectArrow option {
  color: #000;
  padding: 10px;
}

.select:after {
  content: "▼";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  font-size: 15px;
  border: none;
  outline-color: #1e82ae;
  color: #000;
  padding: 7px 10px 5px;
  pointer-events: none;
}

.select {
  position: relative;
  width: 220px;
}

.selecto {
  padding: 3px 20px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/modals/product-version-edit-modal/product-version-edit-modal.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,eAAA;AAEA;EACI,0BAAA;AACJ;;AAEA;EACI,0BAAA;AACJ;;AAEA;EACI,0BAAA;AACJ;;AAEA;EACI,gBAAA;EACA,gBAAA;EACA,WAAA;AACJ;;AAEA;EACI,WAAA;AACJ;;AAEA;EACI,kBAAA;EACA,sDAAA;EACA,UAAA;EACA,qBAAA;EACA,iBAAA;EACA,gBAAA;EACA,OAAA;EACA,sBAAA;EACA,WAAA;AACJ;;AAEA;EACI,iBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;AACJ;;AAEA;EACI,cAAA;EACA,gBAAA;AACJ;;AAEA;EACI,0BAAA;AACJ;;AAEA;EACI,0BAAA;AACJ;;AAEA;EACI,0BAAA;AACJ;;AAEA;EACI,oCAAA;AACJ;;AAEA;EACI,+BAAA;AACJ;;AAGI;EACI,2BAAA;AAAR;;AAIA;EACI,YAAA;AADJ;;AAIA;EACI,aAAA;AADJ;;AAIA;EACI,UAAA;AADJ;;AAIA;EACI,oCAAA;AADJ;;AAGA;EAGI,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;AAAJ;;AAGA;EACI,WAAA;EACA,aAAA;AAAJ;;AAGA;EACI,YAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,eAAA;EACA,YAAA;EACA,sBAAA;EACA,WAAA;EACA,qBAAA;EACA,oBAAA;AAAJ;;AAGA;EACI,kBAAA;EACA,YAAA;AAAJ;;AAEA;EACI,4BAAA;AACJ","sourcesContent":["/*DBC Override*/\n\n::ng-deep mat-label {\n    font-size: 16px !important;\n}\n\n::ng-deep .mat-input-element {\n    font-size: 16px !important;\n}\n\n::ng-deep .mat-select {\n    font-size: 16px !important;\n}\n\n.dbc-material-form {\n    min-width: 150px;\n    max-width: 500px;\n    width: 100%;\n}\n\n.dbc-material-full-width {\n    width: 100%;\n}\n\n.gallery-Prod-Version {\n    position: relative;\n    transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1);\n    opacity: 1;\n    display: inline-block;\n    max-height: 250px;\n    max-width: 250px;\n    zoom: 1;\n    vertical-align: bottom;\n    margin: 3px;\n}\n\n.gallery-Prod-Version-Item {\n    max-height: 250px;\n    max-width: 250px;\n}\n\n.selectedImage {\n    width: 20px;\n    height: 20px;\n    position: absolute;\n    left: 120px;\n    margin-top: -118px;\n}\n\ndiv.scroll-list {\n    overflow: auto;\n    max-height: 70vh;\n}\n\n.drag-over {\n    border: #ff525b dashed 2px;\n}\n\n.drag-hint {\n    border: #ffc100 dashed 2px;\n}\n\n.drag-target-border {\n    border: #00bfff dashed 2px;\n}\n\n.nav-link.active {\n    background-color: #eaeaea !important;\n}\n\n.defaultImage {\n    border-left: 10px solid #28a745;\n}\n\n.my-code-editor {\n    .editorContainer {\n        height: calc(100vh - 100px);\n    }\n}\n\n.green-tick {\n    color: green;\n}\n\n.yellow-tick {\n    color: yellow;\n}\n\n.red-tick {\n    color: red;\n}\n\n.selected-image {\n    border: 2px solid #28a745 !important;\n}\nselect.mySelectArrow {\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    outline: 1px solid;\n    border-radius: 5px;\n    border: none;\n    color: #1e82ae;\n    width: 100%;\n    padding: 5px 5px;\n    font-size: 15px;\n}\n\nselect.mySelectArrow option {\n    color: #000;\n    padding: 10px;\n}\n\n.select:after {\n    content: '\\25BC';\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    font-size: 15px;\n    border: none;\n    outline-color: #1e82ae;\n    color: #000;\n    padding: 7px 10px 5px;\n    pointer-events: none;\n}\n\n.select {\n    position: relative;\n    width: 220px;\n}\n.selecto {\n    padding: 3px 20px!important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
